<template>
  <div class="fishSales">
    <div class="content-container">
      <div class="titieMian">
        <div class="title-container">成鱼销售</div>
        <div class="select-container">
          <div class="select-container-box">
            <span>基地&nbsp;&nbsp;</span>
            <el-select v-model="fishBaseId" filterable placeholder="所在基地" size="small" @change="baseChange">
              <el-option v-for="(item, index) in baseList" :key="index" :label="item.value" :value="item.key">
              </el-option>
            </el-select>
          </div>
          <div class="select-container-box">
            <span>时间&nbsp;&nbsp;</span>
            <el-date-picker size="small" v-model="start" type="date" :clearable="false" placeholder="开始日期" value-format="yyyy-MM-dd" @change="changeTime(0)"
              :picker-options="pickerTimeOptions">
            </el-date-picker>
          </div>
          <div class="select-container-box" style="padding: 0 5px">
            <span>至</span>
          </div>
          <div class="select-container-box" style="padding: 0 1px">
            <el-date-picker size="small" v-model="end" type="date" :clearable="false" placeholder="结束日期" value-format="yyyy-MM-dd" @change="changeTime(1)"
              :picker-options="pickerTimeOptions">
            </el-date-picker>
          </div>
          <!-- <div class="select-container-box">
            <span>在&nbsp;&nbsp;</span>
            <el-select v-model="type" filterable size="small">
              <el-option v-for="(item, index) in typeList" :key="index" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="select-container-box">
            <span>查找&nbsp;&nbsp;</span>
            <el-input placeholder="请输入关键字" v-model="keyWord" :maxlength="num" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" prefix-icon="el-icon-search"
              size="small" class="search-input" clearable>
            </el-input>
          </div> -->
          <el-popover class="pop-condition" placement="bottom" width="580" v-model="popoverVisible" trigger="click">
            <div class="condition">
              <section class="mask">
                <div class="popover-container-box">
                  <span class="popover-label">单据编号：</span>
                  <el-input placeholder="请输入" v-model="number" :maxlength="num" size="small" class="search-input" clearable>
                  </el-input>
                </div>
                <div class="popover-container-box">
                  <span class="popover-label">塘口：</span>
                  <el-input placeholder="请输入" v-model="pondNo" :maxlength="num" size="small" class="search-input" clearable>
                  </el-input>
                </div>
                <div class="popover-container-box">
                  <span class="popover-label">周期：</span>
                  <el-input placeholder="请输入" v-model="batch" :maxlength="num" size="small" class="search-input" clearable></el-input>
                </div>
                <div class="popover-container-box">
                  <span class="popover-label">品种：</span>
                  <el-input placeholder="请输入" v-model="fish" :maxlength="num" size="small" class="search-input" clearable></el-input>
                </div>
                <div class="popover-container-box">
                  <span class="popover-label">客户：</span>
                  <el-input placeholder="请输入" v-model="provider" :maxlength="num" size="small" class="search-input" clearable></el-input>
                </div>
                <div class="popover-container-box">
                  <span class="popover-label">制单人：</span>
                  <el-input placeholder="请输入" v-model="userName" :maxlength="num" size="small" class="search-input" clearable></el-input>
                </div>
              </section>
              <div class="comfirm">
                <span @click="popoverVisible = false">关闭</span>
                <span @click="search(1)">查询</span>
              </div>
            </div>
            <div class="more" slot="reference">更多条件</div>
          </el-popover>
          <audit-status :audit-status.sync="auditStatus" />
          <div class="select-container-box">
            <el-button size="small" type="info" plain @click="search(1)" class="query">查询</el-button>
            <el-button size="small" type="info" plain @click="add" class="add" v-if="edit">增加</el-button>
            <!-- <el-button size="small"  type="info" plain @click="batchAuditOrder" class="query" style="width: auto;">批量审核</el-button> -->
            <!-- <el-button size="small"  type="info" plain  class="outPut">导出</el-button> -->
            <ExportExcelBtn apiUrl="/api/FishSale/Export" :queryParamsObj="queryParams" fileName="成鱼销售.xls" />
          </div>
        </div>
      </div>
      <div class="table-container">
        <el-table :data="fishSalesList.list" @row-dblclick="dataBackFillGoods" style="width: 100%" size="medium" :summary-method="getSummaries"
          :default-sort="{ prop: 'date', order: 'descending' }" show-summary>
          <i slot="empty" style="font-style: normal">该时间段暂无数据</i>

          <el-table-column type="expand">
            <template slot-scope="props">
              <div class="fish-sale-expand-wrap">
                <c-descriptions>
                  <c-descriptions-row v-for="(item, index) in props.row.detalis" :key="index" grid-template-columns="1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr">
                  <c-descriptions-item label="塘口">{{
                    item.pondName
                  }}</c-descriptions-item>
                  <c-descriptions-item label="周期">{{
                    item.batchNo
                  }}</c-descriptions-item>
                  <c-descriptions-item label="渔种">{{
                    item.fish
                  }}</c-descriptions-item>
                  <c-descriptions-item label="规格">{{
                    item.spec
                  }}</c-descriptions-item>
                  <c-descriptions-item label="计量单位">{{
                    item.measureUnit
                  }}</c-descriptions-item>
                  <c-descriptions-item label="数量">{{
                    item.detailQuantity
                  }}</c-descriptions-item>
                  <c-descriptions-item label="重量">{{
                    item.detailWeight
                  }}</c-descriptions-item>
                  <c-descriptions-item label="均重">{{
                    item.detailAvgWeight
                  }}</c-descriptions-item>
                  <c-descriptions-item label="单价">{{
                    item.detailUnitPriceTax
                  }}</c-descriptions-item>
                  <c-descriptions-item label="金额">{{
                    item.detailAmountTotal
                  }}</c-descriptions-item>
                  <c-descriptions-item label="调整金额">{{
                    item.detailAmountAdjust
                  }}</c-descriptions-item>
                  <c-descriptions-item label="结算金额">{{
                    item.detailFinalAmount
                  }}</c-descriptions-item>
                  </c-descriptions-row>
                </c-descriptions>
                <div class="fish-sale-expand-order-remark">
                  <span class="label">整单备注：</span>
                  <span class="val">{{ fishSaleOrderRemark(props.row) }}</span>
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="date" label="日期" width="70" show-overflow-tooltip :formatter="formatter" align="center">
          </el-table-column>
          <el-table-column prop="number" align="center" label="单据编号" width="130">
          </el-table-column>
          <el-table-column prop="fishBaseName" align="center" label="基地" >
          </el-table-column>
          <el-table-column prop="pondName" align="center" label="塘口" >
          </el-table-column>
          <el-table-column prop="totalQuantity" label="总数量" width="110" show-overflow-tooltip align="center" :formatter="$formatCellNumberKeepTwo">
          </el-table-column>
          <el-table-column prop="totalWeight" label="总重量" width="110" show-overflow-tooltip align="center" :formatter="$formatCellNumberKeepTwo">
          </el-table-column>
          <el-table-column prop="unitPriceTax" align="center" width="110" show-overflow-tooltip label="总均价" :formatter="$formatCellNumberKeepTwo">
          </el-table-column>
          <el-table-column prop="totalAmount" align="center" width="110" label="总金额" show-overflow-tooltip :formatter="$formatCellNumberKeepTwo">
          </el-table-column>
          <el-table-column prop="totalAmountAdjust" label="调整金额" width="110" show-overflow-tooltip align="center" :formatter="$formatCellNumberKeepTwo">
          </el-table-column>
          <el-table-column prop="finalAmount" label="结算金额(元)" width="110" show-overflow-tooltip align="center" :formatter="$formatCellNumberKeepTwo">
          </el-table-column>
          <el-table-column prop="custName" label="客户" align="center" width="150" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="userName" label="制单人" show-overflow-tooltip width="50" align="center"></el-table-column>

          <!-- <el-table-column
            label="追溯码"
            align="center"
            width="70"
          >
            <template slot-scope="scope">
              <span
                class="content-edit"
                @click="getTraceCode(scope.$index, scope.row)"
              >查看追溯码</span>
            </template>
          </el-table-column> -->
          <el-table-column label="操作栏" align="center" width="170">
            <template slot-scope="scope">
              <!-- <span class="content-edit" v-if="scope.row.auditStatus === 0" @click="handleAuditStatus(scope.row)">审核</span> -->
              <span @click="handleEdit(scope.$index, scope.row)" class="content-edit" style="margin-left: 20px">{{ edit ? "编辑" : "查看" }}</span>
              <span @click="handleDelete(scope.$index, scope.row)" class="content-del" v-if="edit">删除</span>
              <!-- <span v-if="scope.row.auditStatus !== 0">已审核</span> -->
            </template>
          </el-table-column>
        </el-table>
      </div>
      <page-change :pageInfo="pageInfo"></page-change>
    </div>
    <el-dialog title="查看追溯码" :visible.sync="dialogVisible" width="660px" :before-close="handleClose">
      <div class="left">
        <vue-qr id="qrcode" :logoSrc="config.logo" :text="config.value" :size="config.size" :margin="0"></vue-qr>
        <div style="text-align: center; line-height: 32px">
          追溯编码：{{ rowCode }}
        </div>
      </div>
      <div class="right">
        <div>
          <el-radio v-model="radio" label="1" @change="changeSize(1)">
            尺寸： 430*430 （15cm）
          </el-radio>
          <el-radio v-model="radio" label="2" @change="changeSize(2)">
            尺寸： 344*344 （12cm）
          </el-radio>
          <el-radio v-model="radio" label="3" @change="changeSize(3)">
            尺寸： 258*258 （8cm）
          </el-radio>
          <el-button type="primary" @click="downloadImg($event)">下载追溯码</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import PageChange from "../../common/PageChange";
import AuditStatus from "@/components/AuditStatus";
import { mapState, mapActions } from "vuex";
import { modules } from "../../../store";
import { storage } from "../../../service/storage";
import checkPermission from "../../../service/checkPermission.js";
import mixins from "@/common/MixIn.js";
import { resolveFishBaseKeyFromList, fishBaseIdForQuery } from "@/common/resolveFishBaseSelection.js";
import baseUrl from "../../../service/base-url";
import VueQr from "vue-qr";
import ExportExcelBtn from "../../common/ExportExcelBtn";
export default {
  name: "fishSales",
  mixins: [mixins],
  components: {
    PageChange,
    VueQr,
    AuditStatus,
    ExportExcelBtn,
  },
  data () {
    return {
      popoverVisible: false,
      num: 20,
      tangkou: "全部", //基地
      type: "",
      radio: "1",
      config: {
        // ../../../assets/images/qualityTracing/logo.png
        value: "", //显示的值、跳转的地址
        logo: require("../../../assets/images/qualityTracing/logo.png"), //中间logo的地址
        size: 430,
      },
      dialogVisible: false,
      rowCode: "",
      typeList: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "pondNo",
          label: "所在塘口",
        },
        // {
        //   value: "batch",
        //   label: "周期"
        // },
        {
          value: "fish",
          label: "品种",
        },
        {
          value: "provider",
          label: "客户",
        },
      ],
      fishBaseId: "",
      baseList: [], //基地列表
      start: "", //开始时间
      end: "", //结束时间
      pondNo: "",
      batch: "",
      fish: "",
      provider: "",
      number: "", //单据编号
      userName: "", //制单人
      pickerTimeOptions: {
        // 限制日期
        disabledDate (time) {
          return time.getTime() > Date.now() - 8.64e6;
        },
      },
      keyWord: "", //关键字查找

      pageInfo: {
        pageNumber: 1, // 当前页数
        totalPages: 0, // 总页数
        pageFunc: this.search, // 当前页数需要调用的函数
        pageSize: 10, // 当前页数
      },
      auditStatus: "", //审核状态 0-待审核 1-已审核
    };
  },
  methods: {
    ...mapActions(modules.fishSales, [
      "getfishSalesData", //分页查询数据
      "getfishSalesDataV2", //分页查询数据V2
      "delFishSalesDetail", //删除
      "delFishSalesList", //删除主单
    ]),
    ...mapActions(modules.base, ["getAllBaseList"]), //基地
    ...mapActions(modules.auditOrder, [
      "auditFishOrder",
      "auditFishOrderByMouth",
    ]), // 审核
    //记住基地
    baseChange (e) {
      storage.set("base", e);
    },
    //存储选中时间
    changeTime (type) {
      if (type == 0) {
        storage.set("start", this.start);
      } else {
        storage.set("end", this.end);
      }
    },
    // 格式化指定列时间
    formatter (row) {
      if (!row.date) {
        return false;
      }
      return this.$timeformatDay(row.date);
    },
    handleClose (done) {
      this.dialogVisible = false;
    },
    //双击进入编辑页面

    dataBackFillGoods (row, event) {
      // if(row.auditStatus !== 0) return
      this.$router.push({
        name: "addFishSales",
        query: {
          id: row.orderId,
        },
      });
    },
    //获取鱼基地
    getBaseData () {
      this.getBaseList()
        .then((rsp) => {
          console.dir(rsp);
        })
        .catch((err) => {
          console.dir(err);
        });
    },
    //查询数据
    search (pageNum) {
      // 设置sessionStorage
      sessionStorage.setItem("fishSalesKeyword", this.keyWord);
      let obj = this.queryParams;
      obj.pageIndex = this.pageInfo.pageNumber = pageNum || 1;

      this.getfishSalesDataV2(obj)
        .then((rsp) => {
          if (rsp.status === 200) {
            this.pageInfo.totalPages = rsp.data.total;
          }
        })
        .catch((err) => {
          console.dir(err);
        });
      
      this.popoverVisible = false
    },
    //合计显示格式
    getSummaries (param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if ([1, 2, 3, 4, 11, 12].indexOf(index) >= 0) {
          sums[index] = "--";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (!values.every((value) => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
        } else {
          sums[index] = "--";
        }
      });

      let amount = parseFloat(sums[8]);
      let weight = parseFloat(sums[6]);
      sums[7] = weight == 0 ? 0 : (amount / weight).toFixed(2);

      return sums.map((item) => {
        if (typeof item === "number" && !isNaN(item)) {
          item = item.toFixed(2);
        }
        return item;
      });
    },
    // 筛选过滤
    filterHandler (value, row, column) {
      const property = column["property"];
      return row[property] === value;
    },
    // 展开明细-行备注：列表/保存接口为 detailRemark，与主单 remark 区分
    fishSaleLineRemark (item) {
      if (!item) {
        return "";
      }
      const v =
        item.remark ||
        item.detailRemark ||
        item.DetailRemark ||
        item.Remark;
      return v == null || v === "" ? "" : String(v);
    },
    // 展开区-主单备注（只挂在行数据上、不在 detalis 子项里时）
    fishSaleOrderRemark (row) {
      if (!row) {
        return "";
      }
      const v = row.remark || row.Remark;
      return v == null || v === "" ? "" : String(v);
    },
    //添加
    add () {
      this.$router.push({
        name: "addFishSales",
        query: {
        },
      });
    },
    // 查看追溯码
    getTraceCode (index, row) {
      // 二维码跳转地址
      this.config.value = `${baseUrl.mobileServer}?c=${row.traceCode}`;
      // this.config.value = `http://ylwm.t.nxin.com/qualityTracing?id=${
      //   row.id
      // }&code=${row.code}`;
      // this.config.value = `http://10.70.1.36:8080/qualityTracing?id=${
      //   row.id
      // }&code=${row.code}`;
      console.log(this.config.value);
      this.dialogVisible = true;
      this.rowCode = row.traceCode;
    },
    // 修改追溯码尺寸
    changeSize (index) {
      switch (index) {
        case 1:
          this.config.size = 430;
          break;
        case 2:
          this.config.size = 344;
          break;
        case 3:
          this.config.size = 258;
          break;
        default:
          break;
      }
    },
    // 下载二维码
    downloadImg (e) {
      var oQrcode = document.querySelector("#qrcode img");
      var url = oQrcode.src;
      var a = document.createElement("a");
      var event = new MouseEvent("click");
      // 下载图名字
      a.download = "追溯码:" + this.rowCode;
      //url
      a.href = url;
      //合成函数，执行下载
      a.dispatchEvent(event);
    },
    //编辑
    handleEdit (index, row) {
      this.$router.push({
        name: "addFishSales",
        query: {
          id: row.orderId,
        },
      });
    },
    handleDelete (index, row) {
      //删除
      let pageIndex = this.pageInfo.pageNumber;
      if (this.pageInfo.totalPages % 10 === 1) {
        pageIndex -= 1;
      }
      this.$confirm("是否删除此记录", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          await this.delFishSalesList(row.orderId);
          this.search(pageIndex);
          this.$message({
            message: "删除成功",
            type: "success",
          });
        })
        .catch((err) => {
          this.$Alert.info({
            content: err.response.data,
            duration: 5000,
            status: "error",
          });
          // this.$message.error(err.response.data);
        });
    },
    // 审核
    async handleAuditStatus (row) {
      const confirmRes = await this.$confirm("确认审核通过该单据?").catch(
        (err) => err
      );
      if (confirmRes !== "confirm") return;
      await this.auditFishOrder({
        id: row.orderId,
        auditStatus: 1,
      }).catch((err) => {
        this.$Alert.info({
          content: err.response.data,
          duration: 5000,
          status: "error",
        });
      });
      this.search();
    },
    // 批量审核
    async batchAuditOrder () {
      const confirmRes = await this.$confirm("", "批量操作", {
        confirmButtonText: "批量审核",
        cancelButtonText: "批量驳回",
        center: true,
        distinguishCancelAndClose: true,
      }).catch((err) => err);
      if (confirmRes === "close") return;
      const auditStatus = confirmRes === "confirm" ? 1 : 0;
      const params = {
        auditStatus, // 审核状态 0-待审核 1-已审核 2-审核不通过
        fishStockAbstractId: 2001, // 苗种采购 = 2000 成鱼销售 = 2001
        fishBaseId: fishBaseIdForQuery(this.fishBaseId, this.baseList),
        startDate: this.start,
        endDate: this.end,
        fish: this.fish,
        batch: this.batch,
        provider: this.provider,
        number: this.number,
        userName: this.userName,
        pondNo: this.pondNo,
        pageIndex: 1, // 当前页数(从1开始)
        pageSize: 10000, // 分页条数
      };
      // if (this.type === "") {
      //   params.fish = this.keyWord;
      //   params.provider = this.keyWord;
      //   params.pondNo = this.keyWord;
      //   params.batch = this.keyWord;
      // } else {
      //   params[this.type] = this.keyWord;
      // }
      await this.auditFishOrderByMouth(params).catch((err) => {
        this.$Alert.info({
          content: err.response.data,
          duration: 5000,
          status: "error",
        });
      });
      this.search();
    },
  },
  async mounted () {
    // sessionstorage记住查找关键字
    this.judgeSession("fishSalesKeyword");
    this.keyWord = this.word;

    this.baseList = await this.getAllBaseList({ forQueryAll: true });
    this.fishBaseId = resolveFishBaseKeyFromList(
      this.baseList,
      storage.get("base")
    );
    this.search(1); //查询
  },
  //缓存路由组件重新被激活 事件，重新查询列表数据
  activated () {
    this.search(this.pageInfo.pageNumber);
  },
  computed: {
    ...mapState(modules.fishSales, ["fishSalesList"]),
    getPondFilterList () {
      const res = new Map();
      let fiterList = this.fishSalesList.list
        .map((m) => ({
          value: m.pondName,
          text: m.pondName,
        }))
        .filter((a) => !res.has(a.text) && res.set(a.text, 1));
      return fiterList;
    },
    getFishFilterList () {
      const res = new Map();
      let fiterList = this.fishSalesList.list
        .map((m) => ({
          value: m.fish,
          text: m.fish,
        }))
        .filter((a) => !res.has(a.text) && res.set(a.text, 1));
      return fiterList;
    },
    getPeriodFilterList () {
      const res = new Map();
      let fiterList = this.fishSalesList.list
        .map((m) => ({
          value: m.batchNumber,
          text: m.batchNumber,
        }))
        .filter((a) => !res.has(a.text) && res.set(a.text, 1));
      return fiterList;
    },
    queryParams () {
      let obj = {
        pageIndex: this.pageInfo.pageNumber || 1,
        pageSize: this.pageInfo.pageSize,
        fishBaseId: fishBaseIdForQuery(this.fishBaseId, this.baseList),
        startDate: this.start,
        endDate: this.end,
        fish: this.fish,
        batch: this.batch,
        provider: this.provider,
        number: this.number,
        userName: this.userName,
        pondNo: this.pondNo,
        AuditStatus: this.auditStatus, //审核状态 0-待审核 1-已审核
      };
      // if (this.type === "") {
      //   obj.fish = this.keyWord;
      //   obj.provider = this.keyWord;
      //   obj.pondNo = this.keyWord;
      //   obj.batch = this.keyWord;
      // } else {
      //   obj[this.type] = this.keyWord;
      // }
      return obj;
    },
  },

  //默认时间
  created () {
    let startTime = storage.get("start");
    let endTime = storage.get("end");
    if (startTime) {
      this.start = startTime;
    } else {
      const start = new Date();
      start.setDate(1);
      this.start = this.$timeformatDay(start);
    }
    if (endTime) {
      this.end = endTime;
    } else {
      this.end = this.$timeformatDay(new Date());
    }
  },
};
</script>
<style lang="stylus">
.fishSales {
  .el-dialog__header {
    position: relative;
    box-sizing: border-box;
    background: linear-gradient(270deg, rgba(51, 137, 255, 1), rgba(31, 156, 244, 1), rgba(49, 170, 255, 1));
    padding: 10px 20px 10px;
    width: 660px;
  }

  .el-dialog__headerbtn {
    position: absolute;
    top: 23px;
    right: 35px;
  }

  .el-icon-close:before {
    position: absolute;
    top: -10px;
    color: #fff;
  }

  .el-dialog__title {
    font-size: 18px;
    font-family: MicrosoftYaHei;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
  }

  .el-dialog__body {
    display: flex;
    height: 350px;
  }

  .left {
    width: 42%;
    height: 300px;
    margin-left: 15px;
    margin-top: 15px;

    // border:1px solid red;
    img {
      width: 100%;
      height: 275px;
    }
  }

  .right {
    width: 50%;
    height: 276px;
    background: #F5F6F7;
    margin-left: 26px;
    margin-top: 15px;

    >div {
      padding-left: 30px;
    }

    .el-radio {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      font-size: 8px;
      font-family: MicrosoftYaHei;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
      line-height: 25px;
      margin-left: 0;
    }

    .el-radio:first-child {
      margin-top: 32px;
    }

    .el-radio__label {
      font-size: 16px;
      font-family: MicrosoftYaHei;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
    }

    .el-button--primary {
      width: 210px;
      height: 40px;
      background: rgba(51, 137, 255, 1);
      border-radius: 2px;
      margin-top: 25px;

      span {
        font-size: 7px;
        font-family: MicrosoftYaHei;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
      }
    }
  }

  // 成鱼销售展开区：子单+整单备注同一 #FFFBF4 底，与 CDescriptions 一致
  .fish-sale-expand-wrap {
    background-color: #FFFBF4;
    padding: 20px 50px;
  }
  .fish-sale-expand-wrap .descriptions {
    background-color: transparent !important;
    padding: 0 !important;
  }
  .fish-sale-expand-order-remark {
    display: flex;
    align-items: flex-start;
    margin-top: 0;
    padding-top: 4px;
    font-size: 14px;
    line-height: 1.4;
    .label {
      flex-shrink: 0;
      color: rgba(127, 152, 186, 1);
    }
    .val {
      color: rgba(75, 75, 75, 1);
      word-break: break-all;
    }
  }
}

.pop-condition {
  .more {
    margin-left: 20px;
    padding: 0 20px;
    line-height: 32px;
    background: linear-gradient(180deg, rgba(255, 255, 255, 1), rgba(230, 230, 230, 1));
    border: 1px solid rgba(198, 198, 198, 1);
    border-radius: 4px;
    color: #333333;
    cursor: pointer;
  }
}

.el-popover {
  width: 580px !important;

  .unit {
    display: inline-block;
    line-height: 32px;
    width: 180px;
    text-align: left;
  }

  .condition {
    color: #333;
    font-size: 16px;

    .more {
      height: 32px;
      padding: 0 12px;
      border-radius: 5px;
      line-height: 32px;
      font-size: 14px;
      color: #333;
      cursor: pointer;
      background: linear-gradient(180deg, rgba(255, 255, 255, 1), rgba(230, 230, 230, 1));
      border: 1px solid rgba(198, 198, 198, 1);
    }
  }

  .mask {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 5px 20px 15px 20px;
    z-index: 20;
    font-size: 16px;
    color: #666;
    background: #fff;

    .more {
      margin-left: 20px;
    }

    .popover-container-box {
      width: 260px;
      margin-top: 15px;
      display: flex;

      .popover-label {
        width: 130px;
      }
    }

    .el-input__inner {
      height: 36px;
      width: 180px;
    }

    >div {
      &:nth-child(2n) {
        text-align: right;
        padding-left: 0;

        >span {
          width: 80px;
          text-align: right;
        }
      }
    }
  }

  .comfirm {
    text-align: center;
    font-size: 16px;

    >span {
      display: inline-block;
      width: 100px;
      margin: 15px 0;
      border: 1px solid #BBBBBB;
      border-radius: 4px;
      line-height: 36px;
      background: #fff;
      cursor: pointer;

      &:nth-child(2) {
        margin-left: 20px;
        border: 1px solid #3389FF;
        color: #fff;
        background: #3389FF;
      }
    }
  }
}
</style>
